import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const OccupancyKpiDtoSchema = z.object({
  marketMedian: z.number().nullable(),
  currentValue: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
});

export const GetOccupancyKpiRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

export const GetOccupancyKpiResponseDtoSchema = OccupancyKpiDtoSchema;

export type OccupancyKpiDto = z.infer<typeof GetOccupancyKpiResponseDtoSchema>;
export type GetOccupancyKpiRequestDto = z.infer<
  typeof GetOccupancyKpiRequestDtoSchema
>;

export type GetOccupancyKpiResponseDto = z.infer<
  typeof GetOccupancyKpiResponseDtoSchema
>;

export const getOccupancyKpi = async (
  params: GetOccupancyKpiRequestDto,
  config?: AxiosRequestConfig<GetOccupancyKpiRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/occupancy-kpi`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetOccupancyKpiResponseDtoSchema));
};
